'use client';

import { c as _c } from "react/compiler-runtime";
import * as SubframeCore from '@subframe/core';
import { FeatherChevronsUpDown, FeatherEye, FeatherGavel, FeatherGift, FeatherHeartHandshake, FeatherHome, FeatherLayers, FeatherLayoutDashboard, FeatherList, FeatherLogOut, FeatherPiggyBank, FeatherPlus, FeatherScale, FeatherSend, FeatherSettings, FeatherUser } from '@subframe/core';
import { useRouter } from 'next/navigation';
import React from 'react';
import { DropdownMenu } from '../common/DropdownMenu';
import { SidebarWithCollapsibleSections } from '../common/SidebarWithCollapsibleSections';
import * as SubframeUtils from '../utils';
interface DefaultPageLayoutRootProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  className?: string;
}
const DefaultPageLayoutRoot = React.forwardRef<HTMLDivElement, DefaultPageLayoutRootProps>(function DefaultPageLayoutRoot(t0, ref) {
  const $ = _c(53);
  let children;
  let className;
  let otherProps;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = otherProps;
  } else {
    children = $[1];
    className = $[2];
    otherProps = $[3];
  }
  const router = useRouter();
  let t1;
  if ($[4] !== className) {
    t1 = SubframeUtils.twClassNames("flex h-screen w-full items-center", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="bg-brand-50 text-brand-primary text-caption group-hover:bg-brand-100 flex h-8 w-8 items-center justify-center rounded-sm font-bold transition-colors">EP</div>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SubframeCore.DropdownMenu.Trigger asChild={true}><div className="group flex w-full cursor-pointer items-center gap-3 px-1">{t2}<div className="flex min-w-0 shrink-0 grow basis-0 flex-col items-start"><span className="text-caption-bold font-caption-bold text-default-font w-full truncate">Espaço pessoal</span><span className="text-subtext-color text-[10px] font-medium tracking-wider uppercase">Workspace</span></div><FeatherChevronsUpDown className="text-caption font-caption text-subtext-color" /></div></SubframeCore.DropdownMenu.Trigger>;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <DropdownMenu.DropdownItem icon={<FeatherUser />}>Perfil</DropdownMenu.DropdownItem>;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DropdownMenu.DropdownItem icon={<FeatherSettings />}>Configurações</DropdownMenu.DropdownItem>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SubframeCore.DropdownMenu.Root>{t3}<SubframeCore.DropdownMenu.Portal><SubframeCore.DropdownMenu.Content side="bottom" align="start" sideOffset={8} asChild={true}><DropdownMenu>{t4}{t5}<DropdownMenu.DropdownItem icon={<FeatherLogOut />}>Sair</DropdownMenu.DropdownItem></DropdownMenu></SubframeCore.DropdownMenu.Content></SubframeCore.DropdownMenu.Portal></SubframeCore.DropdownMenu.Root>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SidebarWithCollapsibleSections.NavItem icon={<FeatherUser />} className="h-9">Editar perfil</SidebarWithCollapsibleSections.NavItem>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="flex w-full flex-col gap-1">{t7}<SidebarWithCollapsibleSections.NavItem icon={<FeatherLogOut />} className="text-error-600 hover:bg-error-50 active:bg-error-100 h-9">Sair</SidebarWithCollapsibleSections.NavItem></div>;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <SidebarWithCollapsibleSections.NavItem className="h-10 w-full flex-none" icon={<FeatherHome />}>Home</SidebarWithCollapsibleSections.NavItem>;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="flex w-full flex-col items-start gap-1">{t9}<SidebarWithCollapsibleSections.NavItem className="h-10 w-full flex-none" icon={<FeatherLayoutDashboard />}>Meu painel</SidebarWithCollapsibleSections.NavItem></div>;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <FeatherSend />;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <SidebarWithCollapsibleSections.NavItem className="h-9" icon={<FeatherPlus />}>Criar notificação</SidebarWithCollapsibleSections.NavItem>;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <SidebarWithCollapsibleSections.NavItem className="h-9" icon={<FeatherLayers />}>Criar lote de notificações</SidebarWithCollapsibleSections.NavItem>;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <SidebarWithCollapsibleSections.NavItem className="h-9" selected={true} icon={<FeatherEye />}>Ver notificações</SidebarWithCollapsibleSections.NavItem>;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <SidebarWithCollapsibleSections.CollapsibleNavItem label={"Notifica\xE7\xF5es"} icon={t11} selected={true} defaultOpen={true}>{t12}{t13}{t14}<SidebarWithCollapsibleSections.NavItem className="h-9" icon={<FeatherList />}>Ver lotes de notificações</SidebarWithCollapsibleSections.NavItem></SidebarWithCollapsibleSections.CollapsibleNavItem>;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <FeatherPiggyBank />;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <SidebarWithCollapsibleSections.NavItem className="h-9" icon={<FeatherPlus />}>Criar negociação</SidebarWithCollapsibleSections.NavItem>;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <SidebarWithCollapsibleSections.NavItem className="h-9" icon={<FeatherLayers />}>Criar lote de negociações</SidebarWithCollapsibleSections.NavItem>;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <FeatherEye />;
    $[23] = t19;
  } else {
    t19 = $[23];
  }
  let t20;
  if ($[24] !== router) {
    t20 = <SidebarWithCollapsibleSections.NavItem className="h-9" icon={t19} onClick={() => {
      router.push("/negociacoes");
    }}>Ver negociações</SidebarWithCollapsibleSections.NavItem>;
    $[24] = router;
    $[25] = t20;
  } else {
    t20 = $[25];
  }
  let t21;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <SidebarWithCollapsibleSections.NavItem className="h-9" icon={<FeatherList />}>Ver lotes de negociações</SidebarWithCollapsibleSections.NavItem>;
    $[26] = t21;
  } else {
    t21 = $[26];
  }
  let t22;
  if ($[27] !== t20) {
    t22 = <SidebarWithCollapsibleSections.CollapsibleNavItem label={"Negocia\xE7\xF5es"} icon={t16}>{t17}{t18}{t20}{t21}</SidebarWithCollapsibleSections.CollapsibleNavItem>;
    $[27] = t20;
    $[28] = t22;
  } else {
    t22 = $[28];
  }
  let t23;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <FeatherHeartHandshake />;
    $[29] = t23;
  } else {
    t23 = $[29];
  }
  let t24;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <SidebarWithCollapsibleSections.NavItem className="h-9" icon={<FeatherPlus />}>Criar mediação</SidebarWithCollapsibleSections.NavItem>;
    $[30] = t24;
  } else {
    t24 = $[30];
  }
  let t25;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <SidebarWithCollapsibleSections.NavItem className="h-9" icon={<FeatherLayers />}>Criar lote de mediações</SidebarWithCollapsibleSections.NavItem>;
    $[31] = t25;
  } else {
    t25 = $[31];
  }
  let t26;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <SidebarWithCollapsibleSections.NavItem className="h-9" icon={<FeatherEye />}>Ver mediações</SidebarWithCollapsibleSections.NavItem>;
    $[32] = t26;
  } else {
    t26 = $[32];
  }
  let t27;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <SidebarWithCollapsibleSections.CollapsibleNavItem label={"Media\xE7\xE3o e Concilia\xE7\xE3o"} icon={t23}>{t24}{t25}{t26}<SidebarWithCollapsibleSections.NavItem className="h-9" icon={<FeatherList />}>Ver lotes de mediações</SidebarWithCollapsibleSections.NavItem></SidebarWithCollapsibleSections.CollapsibleNavItem>;
    $[33] = t27;
  } else {
    t27 = $[33];
  }
  let t28;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <FeatherScale />;
    $[34] = t28;
  } else {
    t28 = $[34];
  }
  let t29;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <SidebarWithCollapsibleSections.NavItem className="h-9" icon={<FeatherPlus />}>Criar processo arbitral</SidebarWithCollapsibleSections.NavItem>;
    $[35] = t29;
  } else {
    t29 = $[35];
  }
  let t30;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <SidebarWithCollapsibleSections.NavItem className="h-9" icon={<FeatherLayers />}>Criar lote de processos arbitrais</SidebarWithCollapsibleSections.NavItem>;
    $[36] = t30;
  } else {
    t30 = $[36];
  }
  let t31;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <SidebarWithCollapsibleSections.CollapsibleNavItem label="Processo arbitral" icon={t28}>{t29}{t30}<SidebarWithCollapsibleSections.NavItem className="h-9" icon={<FeatherEye />}>Ver processos arbitrais</SidebarWithCollapsibleSections.NavItem></SidebarWithCollapsibleSections.CollapsibleNavItem>;
    $[37] = t31;
  } else {
    t31 = $[37];
  }
  let t32;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <SidebarWithCollapsibleSections.NavItem className="h-10 w-full flex-none" icon={<FeatherGavel />}>Peticionamento</SidebarWithCollapsibleSections.NavItem>;
    $[38] = t32;
  } else {
    t32 = $[38];
  }
  let t33;
  if ($[39] !== t22) {
    t33 = <SidebarWithCollapsibleSections.NavSection label={"M\xF3dulos"}>{t15}{t22}{t27}{t31}{t32}</SidebarWithCollapsibleSections.NavSection>;
    $[39] = t22;
    $[40] = t33;
  } else {
    t33 = $[40];
  }
  let t34;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <SidebarWithCollapsibleSections.CollapsibleNavItem label={"Configura\xE7\xF5es"} icon={<FeatherSettings />}><SidebarWithCollapsibleSections.NavItem className="h-9 w-full flex-none" icon={null}>Financeiro</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className="h-9 w-full flex-none" icon={null}>Painel do Advogado</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className="h-9 w-full flex-none" icon={null}>Templates</SidebarWithCollapsibleSections.NavItem></SidebarWithCollapsibleSections.CollapsibleNavItem>;
    $[41] = t34;
  } else {
    t34 = $[41];
  }
  let t35;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <div className="flex w-full flex-col gap-4">{t34}<SidebarWithCollapsibleSections.CollapsibleNavItem label={"Benef\xEDcios"} icon={<FeatherGift />}><SidebarWithCollapsibleSections.NavItem className="h-9 w-full flex-none" icon={null}>Programa de indicação</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className="h-9 w-full flex-none" icon={null}>Cursos</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className="h-9 w-full flex-none" icon={null}>Responda e Ganhe</SidebarWithCollapsibleSections.NavItem></SidebarWithCollapsibleSections.CollapsibleNavItem></div>;
    $[42] = t35;
  } else {
    t35 = $[42];
  }
  let t36;
  if ($[43] !== t33) {
    t36 = <SidebarWithCollapsibleSections className="hidden md:flex" header={t6} footer={t8}>{t10}{t33}{t35}</SidebarWithCollapsibleSections>;
    $[43] = t33;
    $[44] = t36;
  } else {
    t36 = $[44];
  }
  let t37;
  if ($[45] !== children) {
    t37 = children ? <div className="flex shrink-0 grow basis-0 flex-col items-start gap-4 self-stretch overflow-y-auto bg-neutral-100/30">{children}</div> : null;
    $[45] = children;
    $[46] = t37;
  } else {
    t37 = $[46];
  }
  let t38;
  if ($[47] !== otherProps || $[48] !== ref || $[49] !== t1 || $[50] !== t36 || $[51] !== t37) {
    t38 = <div className={t1} ref={ref} {...otherProps}>{t36}{t37}</div>;
    $[47] = otherProps;
    $[48] = ref;
    $[49] = t1;
    $[50] = t36;
    $[51] = t37;
    $[52] = t38;
  } else {
    t38 = $[52];
  }
  return t38;
});
const DefaultPageLayout = DefaultPageLayoutRoot;